export default {
  computed: {
    allowSendAsUser() {
      return ['messaging', 'tasking', 'polling', 'group_messaging'].includes(this.event.event_type);
    },
  },
};
